
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";

export default {

  head() {
    const title = 'Deactivate Account - Remove Personal Info | iFindCheaters';
    const description = 'Discover how to deactivate your iFindCheaters account and remove your personal information from our database. If you choose to deactivate, we\'ll guide you through the process with care.';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Deactivate iFindCheaters account, Cancel iFindCheaters account, Account deactivation process, Close iFindCheaters account, How to delete iFindCheaters account, Personal data removal iFindCheaters, Account closure iFindCheaters'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/remove-info/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Deactivate account",
            }],
          }
        }
      ]
    };
  },

  name: "removeMyInfo",
  layout: 'clientLayout',
  mixins: [],
  components: {ClientHead, RedSection, CheckBox, },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
